import * as Sentry from '@sentry/react';

export type SentryEnvironment =
  | 'development'
  | 'staging'
  | 'production'
  | 'siloam';

type Args = {
  environment: SentryEnvironment;
  tenant: {
    type: 'id' | 'url';
    value?: string;
  };
  enabled: boolean;
  release?: string;
};

export const initializeSentry = (args: Args) => {
  const { environment, tenant, release } = args;
  let tenantId;
  if (tenant.type === 'id') {
    tenantId = tenant.value;
  } else {
    const url = tenant.value;
    const regex = /\/organizations\/([a-fA-F0-9-]+)\//;
    const regexMatch = url?.match(regex);
    tenantId = regexMatch ? regexMatch[1] : undefined;
  }

  try {
    Sentry.init({
      dsn: 'https://d1cb9656d1b6d1c6bfd495a2ffeb43f7@o4506339234480128.ingest.sentry.io/4506384339763200',
      // See https://docs.sentry.io/platforms/javascript/configuration/integrations/ for available integrations.
      integrations: [],
      // See https://docs.sentry.io/platforms/javascript/performance/ for Performance Monitoring options

      // https://docs.sentry.io/platforms/javascript/configuration/options/#attach-stacktrace
      attachStacktrace: true,
      environment,
      release,
      beforeSend: (event) => {
        event.tags = {
          ...event.tags,
          tenantId,
        };
        return event;
      },
      enabled: args.enabled,
    });
  } catch {
    // Sentry requires internet connection to initialize, so we catch the error here
  }
};
